import { APIClient } from "api/api_helper";
import { TrainingGroup_API, TRAINING_GROUP_ASSIGN_TRAINING_API, Vista_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";

/* ------------------------------------------------------------------
 * TYPES
 * ------------------------------------------------------------------ */

interface TrainingGroupPayload {
  traininggroupid?: number | null;
  traininggroup?: string;
  description?: string | null;
  createdby?: number;
  updatedby?: number;
  updatereason?: string;
  database?: string;
}

/* ------------------------------------------------------------------
 * API CLIENT
 * ------------------------------------------------------------------ */

const api = new APIClient();

/* ------------------------------------------------------------------
 * TRAINING GROUP API
 * ------------------------------------------------------------------ */

export const trainingGroupApiService = {

  // SELECT ALL METHOD
  getSelectAllData: (
    searchText?: string | null,
    trainingtypeid?: string | number | null,
    trainingcategoryid?: string | number | null,
    pageNumber: number = 1,
    pageSize: number = 10,
  ) => {
    const payload = {
      status: "A",
      searchtext: searchText || null,
      trainingtypeid: trainingtypeid ? Number(trainingtypeid) : null,
      trainingcategoryid: trainingcategoryid ? Number(trainingcategoryid) : null,
      currentpage: pageNumber,
      pagesize: pageSize,
    };
    return api.create(TrainingGroup_API.TrainingGroup_API + "SelectAll", payload);
  },

  // INSERT METHOD
  insertData: (payload_data: TrainingGroupPayload) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      ...payload_data,
      createdby: user.userid,
    };
    return api.create(TrainingGroup_API.TrainingGroup_API + "Insert", payload);
  },

  // UPDATE METHOD
  updateData: (payload_data: TrainingGroupPayload) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      ...payload_data,
      updatedby: user.userid,
    };
    return api.create(TrainingGroup_API.TrainingGroup_API + "Update", payload);
  },

  // DELETE METHOD
  deleteData: (payload: { id: number | null; updatereason: string }) => {
    const user = GetUserData() as CurrentUser;
    const deletePayload = {
      traininggroupid: payload.id,
      updatereason: payload.updatereason,
      updatedby: user.userid,
    };
    return api.create(TrainingGroup_API.TrainingGroup_API + "Delete", deletePayload);
  },

  groupTrainingInsert: (payload: any) => {
    return api.create(TRAINING_GROUP_ASSIGN_TRAINING_API.INSERT, payload);
  },

  groupTrainingSelectAll: (payload: any) => {
    return api.create(TRAINING_GROUP_ASSIGN_TRAINING_API.SELECT_ALL, payload);
  },

  groupTrainingDelete: (payload: any) => {
    return api.create(TRAINING_GROUP_ASSIGN_TRAINING_API.DELETE, payload);
  },

  // TALENT DROP DOWNS (Reused from Vista_API)
  trainingTypeDropdown: (payload: any) => {
    return api.create(Vista_API.TrainingTypeDropDown, { ...payload, databaseType: "talent" });
  },

  categoryDropdown: (payload: any) => {
    return api.create(Vista_API.TypeWiseCategoryDropDown, { ...payload, databaseType: "talent" });
  },

  titleDropdown: (payload: any) => {
    return api.create(Vista_API.CategoryWiseTitleDropDown, { ...payload, databaseType: "talent" });
  },

  titleSelectAll: (payload: any) => {
    return api.create(Vista_API.TitleSelectAll, { ...payload, databaseType: "talent" });
  },
};
